import { create } from 'zustand'
import AsyncStorage from '@react-native-async-storage/async-storage'

const STORAGE_KEY = '@checkInPrintSelections'
// Persisted map grows by one entry per event instance otherwise — keep only
// the most recent events (key order is insertion order, oldest first).
const MAX_EVENTS = 10

const useCheckInPrintStore = create((set, get) => ({
    selectionsByEvent: {},
    _hasHydrated: false,

    hydrate: async () => {
        try {
            const stored = await AsyncStorage.getItem(STORAGE_KEY)
            const parsed = stored ? JSON.parse(stored) : {}
            set({
                selectionsByEvent: parsed && typeof parsed === 'object' ? parsed : {},
                _hasHydrated: true,
            })
        } catch {
            set({ _hasHydrated: true })
        }
    },

    saveSelections: async (eventInstanceID, selections) => {
        // Re-insert so a re-saved event counts as most recent — updating an
        // existing key in place would keep its stale insertion position.
        const next = { ...get().selectionsByEvent }
        delete next[eventInstanceID]
        next[eventInstanceID] = selections
        const keys = Object.keys(next)
        if (keys.length > MAX_EVENTS) keys.slice(0, keys.length - MAX_EVENTS).forEach(k => delete next[k])
        set({ selectionsByEvent: next })
        try {
            await AsyncStorage.setItem(STORAGE_KEY, JSON.stringify(next))
        } catch { /* storage failure is non-fatal */ }
    },

    getSelections: (eventInstanceID) => get().selectionsByEvent[eventInstanceID] || null,
}))

export default useCheckInPrintStore
